import React from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { requestApi } from "../api/request";
import { useNavigate } from "react-router";

const TablonContext = React.createContext(null);

export function TablonProvider({ children, initial }) {

    const navigate = useNavigate()

    const [cookies, setCookie, removeCookie] = useCookies(["usuario"]);

    const [ordenes, setOrdenes] = React.useState(initial?.ordenes || []);
    const [orden, setOrden] = React.useState(initial?.orden || null);
    const [vehiculos, setVehiculos] = React.useState([]);
    const [companias, setCompanias] = React.useState([]);
    const [usuarios, setUsuarios] = React.useState([]);
    const [idNewOrder, setIdNewOrder] = React.useState("");

    const notifyError = (txt) => {
        toast.error(txt, { position: "top-center" });
    };

    const getOrdenes = async () => {
        const res = await requestApi({
            url: "/get_ordenes.php",
            messages: {
                pending: "Cargando órdenes",
                success: "Órdenes cargadas",
                error: "No se pudieron cargar las órdenes",
            },
        });

        if (res.ok) {
            setOrdenes(res.data);
        } else {
            notifyError(res.msg);
        }

        return res;
    };

    const getOrden = async (id) => {
        const res = await requestApi({
            url: "/get_orden.php",
            params: { id },
            messages: {
                pending: "Cargando orden",
                success: "Orden cargada",
                error: "No se pudo cargar la orden",
            },
        });

        if (res.ok) {
            setOrden(res.data);
        } else {
            notifyError(res.msg);
        }

        return res.data;
    };

    const postOrden = async (payload) => {
        const res = await requestApi({
            method: "post",
            url: "/post_orden.php",
            data: payload,
            messages: {
                pending: "Guardando orden",
                success: "Orden guardada",
                error: "No se pudo guardar la orden",
            },
        });

        if (!res.ok) {
            notifyError(res.msg);
        } else {
            navigate("/ordenes")
        }

        return res;
    };

    const getDataCrearOrden = async () => {
        const res = await requestApi({
            url: "/get_data_crear_orden.php",
            messages: {
                pending: "Cargando datos",
                success: "Datos cargados",
                error: "No se pudieron cargar los datos",
            },
        });

        if (res.ok) {
            setVehiculos(res.data.vehiculos);
            setCompanias(res.data.companias);
            setUsuarios(res.data.usuarios);
            setIdNewOrder(res.data.id_new_order);
        } else {
            notifyError(res.msg);
        }

        return res;
    };

    const putOrdenDatos = async (id, payload) => {
        const res = await requestApi({
            method: "post",
            url: "/put_orden_datos.php",
            params: { id },
            data: payload,
            messages: {
                pending: "Guardando datos de orden...",
                success: "Datos de orden guardados",
                error: "Error al guardar datos de orden",
            },
        });

        if (!res.ok) {
            notifyError(res.msg);
        }

        return res;
    };

    const putConceptosOrden = async (id, payload) => {
        const res = await requestApi({
            method: "post",
            url: "/put_conceptos_orden.php",
            params: { id },
            data: payload,
            messages: {
                pending: "Guardando conceptos...",
                success: "Conceptos actualizados",
                error: "Error al guardar conceptos",
            },
        });

        if (!res.ok) {
            notifyError(res.msg);
        }

        return res;
    };

    const value = React.useMemo(
        () => ({
            cookies,
            setCookie,
            removeCookie,

            ordenes,
            setOrdenes,
            getOrdenes,

            orden,
            setOrden,
            getOrden,

            postOrden,
            putOrdenDatos,
            putConceptosOrden,

            vehiculos,
            setVehiculos,
            companias,
            setCompanias,
            usuarios,
            setUsuarios,
            idNewOrder,
            setIdNewOrder,
            getDataCrearOrden,
        }),
        [cookies, ordenes, orden, vehiculos, companias, usuarios, idNewOrder]
    );

    return (
        <TablonContext.Provider value={value}>
            {children}
        </TablonContext.Provider>
    );
}

export function useTablon() {
    const ctx = React.useContext(TablonContext);

    if (!ctx) {
        throw new Error("useTablon debe usarse dentro de <TablonProvider />");
    }

    return ctx;
}